const state = {
    inputConfig: new Map()
};
const getters = {
    getConfig: state => (entityName, fieldName) => {
        return state.inputConfig.get(entityName + '_' + fieldName);
    }
};
const actions = {
    registerConfig(context, {entityName, fieldName, config}) {
        context.commit('setInputConfig', {
            key: entityName + '_' + fieldName,
            value: config,
        })
    },
};
const mutations = {
    setInputConfig(state, {key, value}) {
        state.inputConfig.set(key, value);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}